module.exports = __webpack_public_path__ + "img/20.e9c885ca.jpg";